import React, {useEffect, useRef} from "react";
import {Modal} from "react-bootstrap";
import {PSPDFKIT_LICENSE_KEY} from "../../constants";
import {isDevSite} from "../../utils/general";

function PDFEditor({ document }) {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    let instance, PSPDFKit;
    (async function () {
      PSPDFKit = await import("pspdfkit");
      PSPDFKit.unload(container)

      instance = await PSPDFKit.load({
        container,
        document,
        baseUrl: `${window.location.protocol}//${window.location.host}/${process.env.PUBLIC_URL}`,
        licenseKey: isDevSite() ? undefined : PSPDFKIT_LICENSE_KEY
      });

      instance.setViewState((v) =>
        v.set("interactionMode", PSPDFKit.InteractionMode.CONTENT_EDITOR)
      );
    })();

    return () => PSPDFKit && PSPDFKit.unload(container);
  }, []);

  return (
    <div className="w-100 vh-80" ref={containerRef} />
  );
}

function PDFEditorModal({ document, show, onClose }) {
  return <Modal
    aria-labelledby="contained-modal-title-vcenter"
    className="height-95"
    show={show}
    size="xl"
    centered
  >
    <div className="p-3 text-center bg-purple text-white">
      <img className="me-2" src="/assets/icons/info.svg" height={20} width={20} />
      To publish your changes - save, export & re-upload your document
      <button className="transparent-button float-right" onClick={onClose}>
        <img src="/assets/icons/close-white.svg" height={20} width={20} />
      </button>
    </div>
    <PDFEditor document={document} />
  </Modal>
}

export default PDFEditorModal;